import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Layout } from '../components/Layout/Layout';
import PageLoading from '../../../common/componentsV2/elements/PageLoading';
import { RcQuotesStyles } from './BackOfficeMotoQuotes.styles';
import {
  AvvisoAlert,
} from '../../RcQuotes.styles';
import { getQuoteTypes } from '../../../features/utilities/utilitiesActions';
import LambdaLoaderCard from '../../../common/components/redesignComponents/ResultPageComponents/v2/LambdaLoaderCard';
import {
  loadMotoQuotes,
  updateMotoQuotesData,
  resetMotoQuotes,
  addQuoteMotoToCartBackoffice,
  updateSortByMoto,
  removeQuoteMotoBackofficeFromCart,
  checkScrapperResultsMotoBackoffice,
} from '../../../features/backofficeResults/backofficeResultsActions';
// import { generalAlertError } from '../../../common/utils/alerts';
import { V2FontImport } from '../../../common/formInputsV2/V2Fonts';
import ResultOverviewRow from '../../../common/components/redesignComponents/ResultPageComponents/v2/ResultOverviewRow';
import MotoSummaryCard from '../../../common/components/redesignComponents/ResultPageComponents/v2/MotoSummaryCard';
import QuoteCostSummaryCard from '../../../common/components/redesignComponents/ResultPageComponents/v2/QuoteCostSummaryCard';
import GuaranteesMotoModal from '../components/common/Modal/GuaranteesMotoModal';
import { coveragesUtil } from '../../../utils/coverages';
import { primaQuoteTypes } from '../../../common/constants';
import { confirmAlert } from '../../../common/utils/alerts';
import {
  RiskButton,
  RiskButtonRemove,
  RiskCard,
  RiskContainer,
  SelectFirstNotice,
  SelectQuotePlaceholder,
} from '../../../common/components/redesignComponents/ResultPageComponents/v2/ResultSlotCard.styles';
import SelectedQuotesCardsBackoffice from '../../../common/components/redesignComponents/ResultPageComponents/SelectedQuotesCardsBackoffice';
import ButtonComponentLogicBackoffice from '../../../common/components/redesignComponents/ResultPageComponents/ButtonComponentLogicBackoffice';
import ModalQuotesBackoffice from '../../../common/components/redesignComponents/ResultPageComponents/ModalQuotesBackoffice';
import PrimaResultCard from '../../../common/components/redesignComponents/Cards/PrimaResultCard';
import RiskCardSelected from '../../../common/components/redesignComponents/Cards/RiskCardSelected';
import {
  riskCardPrimaStyles,
  riskCardStyles,
} from '../../../common/components/redesignComponents/ResultPageComponents/RcQuotesModal.style';

import ModalQuotesPrimaBackoffice from '../../../common/components/redesignComponents/ResultPageComponents/ModalQuotesPrimaBackoffice';
import SelectedQuotesCardsPrimaBackoffice from '../../../common/components/redesignComponents/ResultPageComponents/SelectedQuotesCardsPrimaBackoffice';
import ButtonComponentLogicPrimaBackoffice from '../../../common/components/redesignComponents/ResultPageComponents/ButtonComponentLogicPrimaBackoffice';
import FailedQuotationsComponent from '../../../common/components/redesignComponents/ResultPageComponents/v2/FailedQuotationsComponent';

function BackOfficeMotoQuotes() {
  const { requestToken } = useParams();
  const [showGuaranteesModal, setShowGuaranteesModal] = useState(false);
  const clearQuotesIntervalRef = useRef(null);
  const requestInfoRef = useRef(null);
  const checkResultsIntervalRef = useRef(null);
  const isPollingStartedRef = useRef(false);
  const [intervalQuotes, setIntervalQuotes] = useState(null);
  const [allScrapperResulsGotten, setAllScrapperResulsGotten] = useState({
    genial_received: false,
    // linear_received: false,
    facile_received: false,
  });
  const state = useSelector((store) => store.backofficeResults.moto_quotes);
  const {
    loading,
    requestInfo,
    quotes,
    failedQuotes,
    // quotationAquistaLoading,
    quotations,
    processingQuote,
    tutelaLegaleQuote,
    addingQuote,
    assistenzaStradaleQuote,
    infortuniConducenteQuote,
    cristalliQuote,
    rivalsaQuote,
    sortBy,
    preventivas_quotes,
  } = state;

  const { quoteTypes } = useSelector((store) => store.utilities.quoteTypes);

  const [counter, setCounter] = useState(180);
  const [currentQuotes, setCurrentQuotes] = useState('diretta');

  const handleCurrentQuotesDisplay = (val) => {
    setCurrentQuotes(val);
  };

  const guaranteesPrima = (quote) => {
    const guarantees = quote.quotation_data_prima_guarantees
      .map((guarantee) => guarantee.slug)
      .filter((g) => g != 'rca' && g != 'furto_incendio');
    if (
      quote.quotation_data_prima_guarantees.find(
        (qg) => qg.slug == 'furto_incendio',
      ) != undefined
    ) {
      guarantees.push('incendio');
      guarantees.push('furto');
    }
    return guarantees;
  };

  // const updateCoverages = (item) => {
  //   toggleMotoCoveragesAction(item.id);
  // };

  // const includesCoverage = (key) => coverages !== null && coverages.includes(key);

  useEffect(() => {
    if (quoteTypes.length === 0) {
      getQuoteTypes();
    }
  }, [quoteTypes]);

  useEffect(() => {
    loadMotoQuotes(requestToken);

    return () => {
      resetMotoQuotes();
    };
  }, []);

  const clearQuotesInterval = () => {
    if (intervalQuotes !== null) {
      clearInterval(intervalQuotes);
      setIntervalQuotes(null);
    }
  };

  const refresh = () => loadMotoQuotes(requestToken);

  clearQuotesIntervalRef.current = clearQuotesInterval;
  requestInfoRef.current = requestInfo;

  const sortQuotes = (sortBy) => {
    updateSortByMoto(sortBy);
  };

  useEffect(() => {
    const iq = setInterval(() => {
      const requestInfo = requestInfoRef.current;
      if (requestInfo !== null && requestInfo.product_id == 1) {
        if (requestInfo.with_preventivas === null) {
          loadMotoQuotes(requestToken);
        }

        if (requestInfo.with_preventivas !== null) {
          clearQuotesIntervalRef.current();
        }
      }
    }, 10000);

    setIntervalQuotes(iq);

    return () => {
      clearQuotesIntervalRef.current();
    };
  }, []);

  useEffect(() => {
    if (requestInfo !== null && requestInfo.quotations) {
      updateMotoQuotesData(requestInfo);
    }
  }, [requestInfo]);

  const checkScrapperResponses = async () => {
    const data = await checkScrapperResultsMotoBackoffice(requestInfo.id);
    if (!data) return false;

    setAllScrapperResulsGotten({
      genial_received: data.genial_received,
      // linear_received: data.linear_received,
      facile_received: data.facile_received,
    });

    if (data.genial_received || data.facile_received) {
      loadMotoQuotes(requestToken);
    }

    return data.received_all;
  };

  useEffect(() => {
    if (!requestInfo?.id) return undefined;

    isPollingStartedRef.current = false;

    if (checkResultsIntervalRef.current) {
      clearInterval(checkResultsIntervalRef.current);
      checkResultsIntervalRef.current = null;
    }

    const initializePolling = async () => {
      const allReceived = await checkScrapperResponses();

      if (!isPollingStartedRef.current && !allReceived) {
        isPollingStartedRef.current = true;

        checkResultsIntervalRef.current = setInterval(async () => {
          const allReceivedInInterval = await checkScrapperResponses();
          if (allReceivedInInterval && checkResultsIntervalRef.current) {
            clearInterval(checkResultsIntervalRef.current);
            checkResultsIntervalRef.current = null;
            isPollingStartedRef.current = false;
          }
        }, 5000);
      }
    };

    initializePolling();

    return () => {
      if (checkResultsIntervalRef.current) {
        clearInterval(checkResultsIntervalRef.current);
        checkResultsIntervalRef.current = null;
        isPollingStartedRef.current = false;
      }
    };
  }, [requestInfo?.id]);

  useEffect(() => {
    const timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);

  const riskQuotations = {};
  [
    ['tutela_legale', tutelaLegaleQuote],
    ['assistenza_stradale', assistenzaStradaleQuote],
    ['infortuni_conducente', infortuniConducenteQuote],
    ['cristalli', cristalliQuote],
    ['rivalsa', rivalsaQuote],
  ].forEach(([id, quote]) => {
    if (quote) {
      riskQuotations[id] = [quote];
    }
  });

  const fetchQuotes = () => {
    loadMotoQuotes(requestToken);
  };

  const selectQuotation = (quoteId) => {
    confirmAlert('Sei Sicuro di aggiungere questa quotazione?', () => addQuoteMotoToCartBackoffice(quoteId, fetchQuotes));
  };

  // const handleRequestSave = () => {
  //   if (processingQuote === null) {
  //     generalAlertError('Seleziona Prima La Responsabilita Civile', 'Errore');
  //     return;
  //   }

  //   navigate(`/quotes/moto/purchase/${requestToken}`);
  // };

  const removeItemFromCart = (quoteId) => {
    confirmAlert('Sei Sicuro di rimuovere questa quotazione?', () => removeQuoteMotoBackofficeFromCart(quoteId, fetchQuotes));
  };

  const getTotal = () => {
    let quoteInProccessAmount = 0;
    let primaGuaranteesPrices = 0;

    if (processingQuote !== null) {
      if (processingQuote.company_id === 2) {
        quoteInProccessAmount = parseFloat(
          processingQuote.quotation_data_prima.quotation_data_prima_guarantees.find(
            (price) => price.slug === 'rca',
          ).quotation_data_prima_guarantee_prices[0].discounted_to_display,
        );
      } else {
        quoteInProccessAmount = parseFloat(processingQuote.amount);
      }
    }

    if (processingQuote !== null && processingQuote.amount !== null) {
      quoteInProccessAmount = parseFloat(processingQuote.amount);
    }

    if (processingQuote.company_id === 2) {
      processingQuote.guarantees.forEach((guarantee) => {
        primaGuaranteesPrices += parseFloat(guarantee.amount) || 0;
      });
    }

    return (quoteInProccessAmount + primaGuaranteesPrices).toFixed(2);
  };

  if (loading) {
    return <PageLoading />;
  }

  const coverages = coveragesUtil.calculateCommonCoverages(
    requestInfo?.product_id ?? 2,
    quotes ?? [],
  );

  return (
    <Layout>
      <div>
        {showGuaranteesModal && (
          <GuaranteesMotoModal
            setShowGuaranteesModal={setShowGuaranteesModal}
            coverages={coverages}
            requestToken={requestToken}
          />
        )}

        <V2FontImport />
        <RcQuotesStyles>
          <div className="resultsPage">
            <ResultOverviewRow>
              <MotoSummaryCard insuranceRequest={requestInfo} />
              <QuoteCostSummaryCard
                processingQuote={processingQuote}
                quoteTypes={quoteTypes}
                riskQuotations={riskQuotations}
                primaQuoteTypes={primaQuoteTypes}
                getTotal={getTotal}
                rcTypeLabel={quoteTypes.length > 0 ? undefined : processingQuote?.product_name}
              />
            </ResultOverviewRow>
            {(allScrapperResulsGotten.genial_received === false || allScrapperResulsGotten.linear_received === false || allScrapperResulsGotten.facile_received === false) && (
              <div className="row my-3">
                <div className="col-12">
                  <LambdaLoaderCard />
                </div>
              </div>
            )}

            {quotations && !quotations.res_civile
              && (
                <AvvisoAlert role="alert">
                  <h4>Avviso!</h4>
                  <p>Il preventivo non è riuscito per problemi relativi ai dati assicurativi. Si prega di contattare il nostro backoffice per ottenere il preventivo o ulteriori informazioni.</p>
                </AvvisoAlert>
              )}

            <RiskContainer className="mb-4 ">
              {processingQuote !== null && processingQuote.company_id === 2
                ? [{ id: 'res_civile', name: 'Responsabilita Civile' }].map(
                  (type, index) => (
                    <React.Fragment key={index}>
                      {quotations && quotations[type.id] && (
                        <RiskCard
                          className={riskCardStyles(requestInfo, type)}
                        >
                          <div className="me-auto">
                            <h5>{type.name}</h5>
                          </div>
                          {processingQuote !== null
                            && type.id === 'res_civile' && (
                              <>
                                {processingQuote
                                  && processingQuote.company_id === 2 && (
                                    <div className="col-12 mb-2">
                                      <PrimaResultCard
                                        requestInfo={requestInfo}
                                        processingQuote={processingQuote}
                                      />
                                    </div>
                                )}
                              </>
                          )}

                          {processingQuote !== null
                            && type.id === 'tutela_legale' && (
                              <>
                                {tutelaLegaleQuote === null ? (
                                  <SelectQuotePlaceholder
                                    data-bs-toggle="modal"
                                    data-bs-target={`#${type.id}`}
                                  >
                                    Seleziona Quotazione!
                                  </SelectQuotePlaceholder>
                                ) : (
                                  <div className="col-12 mb-2">
                                    <RiskCardSelected
                                      quote={tutelaLegaleQuote}
                                      type={type}
                                    />
                                  </div>
                                )}
                              </>
                          )}
                          <div className="d-flex justify-content-end ms-auto gap-2">
                            {type.id === 'res_civile'
                              && processingQuote !== null && (
                                <RiskButtonRemove
                                  className="btn btn-danger"
                                  onClick={() => removeItemFromCart(processingQuote.id)}
                                >
                                  Rimuovi
                                </RiskButtonRemove>
                            )}

                            {type.id === 'tutela_legale'
                              && tutelaLegaleQuote !== null ? (
                                <RiskButtonRemove
                                  className="btn btn-danger"
                                  onClick={() => removeItemFromCart(tutelaLegaleQuote.id)}
                                >
                                  Rimuovi
                                </RiskButtonRemove>
                              ) : type.id === 'tutela_legale'
                              && tutelaLegaleQuote === null
                              && processingQuote !== null ? (
                                <RiskButton
                                  className="btn btn-success"
                                  data-bs-toggle="modal"
                                  data-bs-target={`#${type.id}`}
                                >
                                  Aggiungi
                                </RiskButton>
                                ) : (
                                  ''
                                )}

                            {requestInfo.processing_quotation_id === null
                              && type.id !== 'res_civile' && (
                                <SelectFirstNotice>
                                  Seleziona Prima La Responsibilita Civile
                                </SelectFirstNotice>
                            )}

                            {type.id === 'res_civile' && (
                              <RiskButton
                                className="btn btn-success"
                                data-bs-toggle="modal"
                                data-bs-target={`#${type.id}`}
                              >
                                Aggiungi
                              </RiskButton>
                            )}
                          </div>
                        </RiskCard>
                      )}

                      {processingQuote !== null
                        && processingQuote.company_id === 2 && (
                          <>
                            {processingQuote.quotation_data_prima.quotation_data_prima_guarantees.map(
                              (quote) => (
                                <>
                                  {quote.slug !== 'rca' && (
                                    <RiskCard
                                      className={riskCardPrimaStyles(
                                        primaQuoteTypes.find(
                                          (type) => type.id === quote.slug,
                                        ),
                                        processingQuote,
                                      )}
                                    >
                                      <div className="me-auto">
                                        <h5>
                                          {
                                            primaQuoteTypes.find(
                                              (type) => type.id === quote.slug,
                                            ).name
                                          }
                                        </h5>
                                      </div>
                                      <SelectedQuotesCardsPrimaBackoffice
                                        processingQuote={processingQuote}
                                        type={primaQuoteTypes.find(
                                          (type) => type.id === quote.slug,
                                        )}
                                      />

                                      <ButtonComponentLogicPrimaBackoffice
                                        type={primaQuoteTypes.find(
                                          (type) => type.id === quote.slug,
                                        )}
                                        processingQuote={processingQuote}
                                        requestInfo={requestInfo}
                                      />
                                    </RiskCard>
                                  )}
                                </>
                              ),
                            )}
                          </>
                      )}
                    </React.Fragment>
                  ),
                )
                : quoteTypes.filter((type) => type.id !== 'rc_transportati_minori' || processingQuote?.company_id === 9).map((type, index) => (
                  <React.Fragment key={index}>
                    {quotations && quotations[type.id] && (
                      <RiskCard className={riskCardStyles(requestInfo, type, riskQuotations)}>
                        <div className="me-auto">
                          <h5>{type.name}</h5>
                        </div>
                        <SelectedQuotesCardsBackoffice
                          processingQuote={processingQuote}
                          type={type}
                          refresh={refresh}
                          requestInfo={requestInfo}
                          riskQuotations={riskQuotations}
                        />
                        <ButtonComponentLogicBackoffice
                          type={type}
                          processingQuote={processingQuote}
                          removeItemFromCart={removeItemFromCart}
                          requestInfo={requestInfo}
                          riskQuotations={riskQuotations}
                        />
                      </RiskCard>
                    )}
                  </React.Fragment>
                ))}
            </RiskContainer>

            {quoteTypes.map((type, index) => (
              <ModalQuotesBackoffice
                processingQuote={processingQuote}
                key={index}
                type={type}
                addingQuote={addingQuote}
                sortBy={sortBy}
                sortQuotes={sortQuotes}
                handleCurrentQuotesDisplay={handleCurrentQuotesDisplay}
                currentQuotes={currentQuotes}
                requestInfo={requestInfo}
                counter={counter}
                quotations={quotations}
                requestToken={requestToken}
                refresh={refresh}
                selectQuotation={selectQuotation}
                guaranteesPrima={guaranteesPrima}
                preventivas_quotes={preventivas_quotes}
              />
            ))}

            {processingQuote !== null
              && processingQuote.company_id === 2
              && primaQuoteTypes.map((type, index) => (
                <ModalQuotesPrimaBackoffice
                  processingQuote={processingQuote}
                  key={index}
                  type={type}
                  addingQuote={addingQuote}
                  requestInfo={requestInfo}
                  requestToken={requestToken}
                  guaranteesPrima={guaranteesPrima}
                />
              ))}

            {/* <div className="row mb-4">
              <div className="d-flex align-items-center justify-content-center gap-2 mb-3">
                <button
                  className={`btn ${currentQuotes === 'diretta'
                    ? 'btn-success'
                    : 'btn-outline-success'}`}
                  onClick={() => handleCurrentQuotesDisplay('diretta')}
                >
                  Compagnie Dirette
                </button>
                <button
                  className={`btn ${currentQuotes === 'indiretta'
                    ? 'btn-success'
                    : 'btn-outline-success'}`}
                  onClick={() => handleCurrentQuotesDisplay('indiretta')}
                >
                  Compagnie Indirette
                </button>

              </div>
              {quotes
                && (currentQuotes === 'diretta' || currentQuotes === 'indiretta')
                && quotes.map((quote, index) => (currentQuotes === 'diretta' ? (
                  <React.Fragment key={index}>
                    {quote.company_id === 1 && (
                      <div className="col-12 mb-2" key={quote.id}>
                        <AdriaticCard
                          requestToken={requestToken}
                          requestInfo={requestInfo}
                          key={quote.id}
                          quote={quote.quotation_data_adriatic}
                          quotation={quote}
                          company={quote.company}
                          saved_quote={quote.saved_quotation}
                        />
                      </div>
                    )}
                    {quote.company_id === 2 && (
                      <div className="col-12 mb-2">
                        <PrimaCardMoto
                          requestToken={requestToken}
                          requestInfo={requestInfo}
                          key={quote.id}
                          quotation={quote}
                          saved_quote={quote.saved_quotation}
                          guaranteesPrima={guaranteesPrima}
                          quotationAquistaLoading={quotationAquistaLoading}
                        />
                      </div>
                    )}
                  </React.Fragment>
                ) : currentQuotes === 'indiretta' ? (
                  <>
                    {quote.company_id === null && (
                      <div className="col-12 mb-2">
                        <PreventivassCard
                          requestInfo={requestInfo}
                          key={quote.id}
                          quotation={quote}
                        />
                      </div>
                    )}
                  </>
                ) : (
                  ''
                )))}
            </div> */}

            {failedQuotes !== null && failedQuotes.length > 0 && (
              <FailedQuotationsComponent failedQuotes={failedQuotes} />
            )}
          </div>
        </RcQuotesStyles>
      </div>
    </Layout>
  );
}

export default BackOfficeMotoQuotes;
